/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import * as React from "react";
import styled from "styled-components";

import { theme as siteTheme } from "../theme/theme";

type RewardImageProps = {
  imageUrl: string;
};

const StyledContainer = styled.div`
  border-radius: 12px;
  border: 1px solid ${siteTheme.color.gray300};
  background-color: white;
  height: 158px;
  width: 240px;
  margin: auto;
  overflow: hidden;
  box-shadow: 0px 9px 4px rgba(0, 0, 0, 0.03), 0px 5px 3px rgba(0, 0, 0, 0.04),
    0px 2px 2px rgba(0, 0, 0, 0.05), 0px 1px 1px rgba(0, 0, 0, 0.06),
    0px 0px 1px rgba(0, 0, 0, 0.14);
`;

const StyledImage = styled.img`
  margin: 0 auto;
  height: 100%;
  display: block;
`;

const RewardImage = ({ imageUrl }: RewardImageProps): React.ReactElement => {
  return (
    <StyledContainer>
      <StyledImage src={imageUrl} />
    </StyledContainer>
  );
};

export default RewardImage;
